import React from 'react';
import { Box, CssBaseline, Paper, Stack, ThemeProvider } from '@mui/material';
import theme from '../../theme';
import LanguageSwitcher from '../Topbar/LanguageSwitcher';
import Copyright from '../common/Copyright';
import logo from '../../images/talentsense-logo-1.jpeg';

export const authStyles = {
    page: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        px: 2,
    },
    card: {
        width: '100%',
        maxWidth: 420,
        p: { xs: 4, sm: 5 },
        borderRadius: 3,
        boxShadow: '0 10px 40px rgba(15, 23, 42, 0.08)',
    },
    label: {
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        fontSize: 12,
        fontWeight: 600,
        color: 'text.secondary',
        mb: 0.5,
    },
};

// Shared visual chrome for the auth screens (login, password reset).
// Renders the centered card as a <form>; callers provide the inner fields
// as children and handle submission through onSubmit.
export default function AuthShell({ onSubmit, children }) {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box sx={authStyles.page}>
                <Stack spacing={3} alignItems="center" sx={{ width: '100%', maxWidth: 420 }}>
                    <Paper component="form" onSubmit={onSubmit} sx={authStyles.card} elevation={0} noValidate>
                        <Stack spacing={3}>
                            <Box sx={{ textAlign: 'center' }}>
                                <Box component="img" src={logo} alt="TalentSense"
                                     sx={{ width: '100%', maxWidth: 340, height: 'auto', display: 'inline-block' }} />
                            </Box>
                            <Stack spacing={5}>
                                {children}
                            </Stack>
                        </Stack>
                    </Paper>

                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <LanguageSwitcher />
                    </Box>

                    <Copyright />
                </Stack>
            </Box>
        </ThemeProvider>
    );
}
